import { z } from 'zod'

export const createDishFormSchema = z.object({
  nameRu: z
    .string()
    .min(1, 'Поле не может быть пустым')
    .max(255, 'Максимальная длина 255 символов'),
  nameKk: z
    .string()
    .min(1, 'Поле не может быть пустым')
    .max(255, 'Максимальная длина 255 символов'),
  categoryId: z.string().min(1, 'Поле не может быть пустым'),
  schoolId: z.string().min(1, 'Поле не может быть пустым'),
  canteenId: z.string().min(1, 'Поле не может быть пустым'),
  descriptionRu: z
    .string()
    .min(1, 'Поле не может быть пустым')
    .max(1000, 'Максимальная длина 1000 символов'),
  descriptionKk: z
    .string()
    .min(1, 'Поле не может быть пустым')
    .max(1000, 'Максимальная длина 1000 символов'),
})

export type CreateDishFormValues = z.infer<typeof createDishFormSchema>
